export function isDark(){
    let theme = localStorage.getItem('healthcare_theme');
    if(theme){
        if(theme == 'dark'){
            return true
        }else{
            return false
        }
    }else{
        return false
    }
}